import React from 'react';
import { observer } from 'mobx-react';
import { StringStore } from 'ui/base/input/store';
import { InputChangeEvent, InputProps } from 'ui/base/types';

export type TextInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  store: StringStore;
};

export const TextInput = observer(({ store, ...props }: TextInputProps) => {
  const onChange = React.useCallback((event: InputChangeEvent) => {
    store.setValue(event.target.value);
  }, [store]);

  return <input type='text' value={store.value} onChange={onChange} {...props}/>;
});
